import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { cloneDeep } from "lodash";
import DatePicker from "react-datepicker";
import CloseModal from "../../../Components/CloseModal";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import {
  saveorupdatebranchmaster,
  getunmappedspokes,
  getdetailsbypincode,
  getRegionsByStateId,
} from "../../../Utils/Services/BranchMaster";

toast.configure();

const initForm = {
  branchName: "",
  partnerId: null,
  pincode: "",
  tehsil: "",
  state: "",
  stateId: null,
  regionId: null,
  dateOfEstablishment: "",
  address: "",
  longitude: "",
  latitude: "",
  district: "",
  spokeEntitySet: [],
  status: "",
  isOperational: true,
  errors: {
    branchName: null,
    partnerId: null,
    pincode: null,
    dateOfEstablishment: null,
    address: null,
    latitude: null,
    longitude: null,
    spokeEntitySet: null,
    tehsil: null,
    district: null,
    state: null,
    regionId: null,
    status: null,
  },
};
const userInfo = JSON.parse(localStorage.getItem("userInfo"));
const isITADMIN = userInfo?.role === "ITADMIN";

export class AddEditBranch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tehsilsdropdownvalue: [],
      unmappedspokes: [],
      userTehsil: [],
      userspokes: [],
      pincodedetails: [],
      showModal: false,
      Loading: false,
      showInner: false,
      form: cloneDeep(initForm),
      stateDropdownValues: [],
      districtDropdownValues: [],
      regionDropdownValues: [],
      selectedDate: null,
      mappedspokes: [],
    };
    this._isMounted = false;
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.setState({ showModal: true });
    if (this.props.editData && this.props.action === "edit") {
      let {
        form,
        selectedDate,
        mappedspokes,
        tehsilsdropdownvalue,
        districtDropdownValues,
        stateDropdownValues,
      } = this.state;
      selectedDate = this.props.editData.dateOfEstablishment
        ? new Date(
            this.props.editData.dateOfEstablishment.split("-").reverse().join("-")
          )
        : null;
      let obj = { ...form, ...this.props.editData };
      obj.regionId = this.props.editData?.regionId || null;
      obj.latitude = this.props.editData?.latitude === "" || this.props.editData?.latitude == null ? "0" : this.props.editData?.latitude;
      obj.longitude = this.props.editData?.longitude === "" || this.props.editData?.longitude == null ? "0" : this.props.editData?.longitude;
      obj.isOperational = this.props.editData?.isOperational !== undefined ? this.props.editData.isOperational : true;
      tehsilsdropdownvalue.push({ value: obj.tehsil, label: obj.tehsil });
      districtDropdownValues.push({ value: obj.district, label: obj.district });
      stateDropdownValues.push({
        value: obj.state,
        label: obj.state,
        id: obj.stateId,
      });
      for (
        let i = 0;
        i < (this.props.editData?.spokeDTOSet?.length || 0);
        i++
      ) {
        mappedspokes.push(this.props.editData.spokeDTOSet[i]);
      }
      obj.spokeEntitySet = this.props.editData?.spokeDTOSet || [];
      if (this._isMounted) {
        this.setState(
          {
            form: obj,
            selectedDate,
            mappedspokes,
            tehsilsdropdownvalue,
            districtDropdownValues,
            stateDropdownValues,
          },
          () => {
            if (this.state.form.stateId) {
              this.fetchRegions(this.state.form.stateId);
            }
          }
        );
      }
    }
    this.allspokesdropdown();
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  allspokesdropdown = () => {
    getunmappedspokes().then((res) => {
      if (!this._isMounted) return;
      if (res.error) {
        // Error toast already shown by HTTP interceptor
        return;
      }
      if (res.data.error) {
        // Error toast already shown by HTTP interceptor
        return;
      } else {
        this.setState({ unmappedspokes: res.data });
        if (this.props.action === "edit") {
          let { form, unmappedspokes, mappedspokes } = this.state;
          for (let i = 0; i < mappedspokes.length; i++) {
            unmappedspokes.push(mappedspokes[i]);
          }
          this.setState({ form, unmappedspokes });
        }
      }
    });
  };

  fetchRegions = (stateId) => {
    if (!stateId) return;
    getRegionsByStateId(stateId).then((response) => {
      if (!this._isMounted) return;
      if (response.error) {
        return;
      }
      if (response.data.error) {
        return;
      } else {
        const regions = response.data.map((r) => ({
          value: r.id,
          label: r.regionName,
        }));
        this.setState({ regionDropdownValues: regions });
      }
    });
  };

  alldetailsbypincode = (pincode) => {
    let {
      form,
      stateDropdownValues,
      districtDropdownValues,
      tehsilsdropdownvalue,
    } = this.state;
    getdetailsbypincode(pincode).then((response) => {
      if (!this._isMounted) return;
      if (response.error) {
        return;
      }
      if (response.data.error) {
        return;
      } else {
        const stateSet = new Set();
        const districtSet = new Set();
        const tehsilSet = new Set();
        const tehsils = [];
        const states = [];
        const districts = [];

        for (let i = 0; i < response.data.length; i++) {
          stateSet.add(response.data[i].state);
        }
        stateSet.forEach((s) => {
          const stateItem = response.data.find((d) => d.state === s);
          if (stateItem) {
            states.push({ value: s, label: s, id: stateItem.stateId });
          }
        });
        for (let j = 0; j < response.data.length; j++) {
          districtSet.add(response.data[j].district);
        }
        for (let j of districtSet) {
          districts.push({ value: j, label: j });
        }
        for (let k = 0; k < response.data.length; k++) {
          tehsilSet.add(response.data[k].tehsil);
        }
        for (let k of tehsilSet) {
          tehsils.push({ value: k, label: k });
        }
        form.tehsil = tehsils?.[0]?.value || "";
        form.district = districts?.[0]?.value || "";
        form.state = states?.[0]?.value || "";
        form.stateId = states?.[0]?.id || null;
        this.setState(
          {
            form,
            stateDropdownValues: states,
            districtDropdownValues: districts,
            tehsilsdropdownvalue: tehsils,
          },
          () => {
            if (form.stateId) {
              this.fetchRegions(form.stateId);
            }
          }
        );
      }
    });
  };

  handleModalClose = () => {
    this.setState({ showInner: !this.state.showInner });
  };

  innerModalClose = (modclose) => {
    if (!modclose) {
      this.handleModalClose();
    }
    if (this._isMounted) {
      this.setState({ showModal: false });
    }
    if (this.props.action === "edit") {
      this.props.handleEditBranchMaster();
    } else {
      this.props.handleAddBranch();
    }
  };

  handleSubmit = (performActive) => {
    let { form, mappedspokes } = this.state;

    if (this.props.action === "edit" && performActive) {
      form.status = form.status === true ? false : true;
    }

    let obj = {
      branchName: form.branchName,
      partnerId: form.partnerId || null,
      pincode: form.pincode,
      tehsil: form.tehsil,
      state: form.state,
      stateId: form.stateId || null,
      regionId: form.regionId || null,
      dateOfEstablishment: form.dateOfEstablishment,
      address: form.address,
      longitude: form.longitude === "" || form.longitude == null ? "0" : form.longitude,
      latitude: form.latitude === "" || form.latitude == null ? "0" : form.latitude,
      district: form.district,
      spokeDTOSet: form.spokeEntitySet || [], // Rename to match API
      status: this.props.action === "edit" ? form.status : true, // Default to true for create
      isOperational: form.isOperational !== undefined ? form.isOperational : true,
      errors: form.errors, // Include errors as per cURL
    };

    // Include id and branchcode for edit mode
    if (this.props.action === "edit") {
      obj.id = form.id; // Use id from form (populated from editData)
      obj.branchcode = form.branchcode || form.branchName; // Use branchcode or fallback to branchName
    }

    if (this._isMounted) {
      this.setState({ Loading: true });
    }
    saveorupdatebranchmaster(obj).then((response) => {
      if (!this._isMounted) return;
      this.setState({ Loading: false });
      if (response.data && response.data.error) {
        // Error toast already shown by HTTP interceptor
        return;
      } else {
        this.props.BranchMaster();
        if (this.props.action === "edit") {
          this.setState({ showModal: false });
          toast.success("Data Updated Successfully", {
            type: toast.TYPE.SUCCESS,
            autoClose: 4000,
          });
          this.props.handleEditBranchMaster();
        } else {
          this.setState({ showModal: false });
          toast.success("Data Saved Successfully", {
            type: toast.TYPE.SUCCESS,
            autoClose: 4000,
          });
          this.props.handleAddBranch();
        }
      }
    });
  };

  handleInputChange = (e, name) => {
    e.preventDefault();
    let { form } = this.state;
    form[name] = e.target.value;
    this.setState({ form });
  };

  handlepartnerId = (e, name) => {
    let { form } = this.state;
    form[name] = e.target.value;
    this.setState({ form });
  };

  handleValidatepartnerId = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];

    if (
      (name === "partnerId" && value === null) ||
      e.target.value.length === 0
    ) {
      return this.setState({
        form: { ...form, errors: { ...form.errors, partnerId: null } },
      });
    }

    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (name === "partnerId" && value.length < 4 && value.length !== 6)
    ) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.setState({ form });
    }
  };

  restrictAlphabets = (e) => {
    const regx = "^[0-9]*$";
    if (e.key.match(regx)) {
      return true;
    } else {
      e.preventDefault();
    }
  };

  handleBranchTehsilDistrict = (e, name) => {
    let regx = /^[a-zA-Z][a-zA-Z0-9()\-\. ]*$/g;
    if (e.target.value.match(regx) || e.target.value === "") {
      let { form } = this.state;
      form[name] = e.target.value;
      this.setState({ form });
    }
  };

  handleLongitudeLatitude = (e, name) => {
    let regx = /[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)/;
    if (e.target.value.match(regx) || e.target.value === "") {
      let { form } = this.state;
      form[name] = e.target.value;
      this.setState({ form });
    }
  };

  handleValidateBranchtehsildiststate = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (name === "branchName" && value && e.target.value.trim().length < 3) ||
      (name === "regionId" && !value)
    ) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.setState({ form });
    }
  };

  handleSpoke = (spoke) => {
    let { form } = this.state;
    if (spoke === null) {
      form.spokeEntitySet = [];
      this.setState({ form });
    }
    if (spoke !== null) {
      for (let j = 0; j < spoke.length; j++) {
        spoke[j].dateOfEstablishment = null;
      }
      form.spokeEntitySet = spoke;
      this.setState({ form });
    }
  };

  ValidateLongitudeLatitude = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (value === "" || value === null || value === undefined) {
      form.errors[name] = false; // Allow empty values since default is 0
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.setState({ form });
    }
  };

  handleStateSelectChange = (e, name) => {
    let { form } = this.state;
    let { value } = e;
    form[name] = value;
    if (name === "state") {
      const selectedState = this.state.stateDropdownValues.find(
        (opt) => opt.value === value
      );
      form.stateId = selectedState ? selectedState.id : null;
      form.regionId = null;
      this.setState({ form, regionDropdownValues: [] }, () => {
        if (form.stateId) {
          this.fetchRegions(form.stateId);
        }
      });
    } else {
      this.setState({ form });
    }
  };

  handleRegionSelectChange = (e) => {
    let { form } = this.state;
    form.regionId = e ? e.value : null;
    form.errors.regionId = null;
    this.setState({ form });
  };

  handlePincode = (e, name) => {
    e.preventDefault();
    let { form } = this.state;
    this.clearAll();
    form[name] = e.target.value;
    this.setState({ form });
    if (name === "pincode" && e.target.value.length > 5) {
      this.alldetailsbypincode(e.target.value);
    }
  };

  clearAll = () => {
    let {
      form,
      stateDropdownValues,
      tehsilsdropdownvalue,
      districtDropdownValues,
      regionDropdownValues,
    } = this.state;
    form.tehsil = "";
    form.district = "";
    form.state = "";
    form.stateId = null;
    form.regionId = null;
    stateDropdownValues.splice(0, stateDropdownValues.length);
    districtDropdownValues.splice(0, districtDropdownValues.length);
    tehsilsdropdownvalue.splice(0, tehsilsdropdownvalue.length);
    regionDropdownValues.splice(0, regionDropdownValues.length);

    this.setState({
      form,
      stateDropdownValues,
      tehsilsdropdownvalue,
      districtDropdownValues,
      regionDropdownValues,
    });
  };

  handlevalidationDateOfEstablishment = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (value === "" || value === null || value === undefined) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = false;
      this.setState({ form });
    }
  };

  handleValidatePincode = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (name === "pincode" && value && value.length !== 6)
    ) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.alldetailsbypincode(form.pincode);
      this.setState({ form });
    }
  };

  handleValidateAddressChange = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      value.length < 3
    ) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.setState({ form });
    }
  };

  handleDateOfEstablishment = (date) => {
    let { form, selectedDate } = this.state;
    if (date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const dt = date.getDate();

      const formattedDate = `${dt < 10 ? "0" + dt : dt}-${month < 10 ? "0" + month : month}-${year}`;
      form.dateOfEstablishment = formattedDate;
      selectedDate = date;
      this.setState({ form, selectedDate });
    }
  };

  handleAddressChange = (e, name) => {
    let { form } = this.state;
    form[name] = e.target.value;
    this.setState({ form });
  };

  render() {
    let {
      form,
      showModal,
      showInner,
      Loading,
      tehsilsdropdownvalue,
      userspokes,
      unmappedspokes,
      stateDropdownValues,
      districtDropdownValues,
      regionDropdownValues,
      selectedDate,
      mappedspokes,
    } = this.state;
    let { errors } = form;
    let disableSave = Object.keys(errors).some(
      (error) => errors[error] === true || errors[error] !== null
    );

    let mappedBranchObj = [];
    unmappedspokes.forEach((res) => {
      userspokes &&
        userspokes.forEach((val) => {
          if (res.id === val.id) {
            mappedBranchObj.push(res);
          }
        });
    });

    return (
      <React.Fragment>
        <Modal
          className="product-norm-container"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showModal}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>
              {this.props.action === "edit" ? "Edit Branch" : "Add Branch"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {Loading ? (
              <h4 className="text-center">LOADING...</h4>
            ) : (
              <>
                <div className="row">
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>Branch Name
                    </label>
                    <input
                      type="text"
                      maxLength="100"
                      name="branchName"
                      value={form.branchName || ""}
                      onChange={(e) => {
                        this.handleBranchTehsilDistrict(e, "branchName");
                      }}
                      disabled={this.props.action === "edit" || !isITADMIN}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "branchName")
                      }
                      placeholder="Enter Branch"
                      className={`form-input ${
                        errors.branchName ? "error-input-border" : ""
                      }`}
                    />
                    {errors.branchName && (
                      <span className="errorMsg">
                        {errors.branchName === true
                          ? "Enter Valid Branch Name"
                          : errors.branchName}
                      </span>
                    )}
                  </div>

                  <div className="mb-4 col-md-4">
                    <label>Partner Id</label>
                    <input
                      type="text"
                      pattern="\d*"
                      maxLength="6"
                      name="partnerId"
                      value={form.partnerId || ""}
                      onKeyPress={this.restrictAlphabets}
                      onChange={(e) => {
                        this.handlepartnerId(e, "partnerId");
                      }}
                      disabled={!isITADMIN}
                      onBlur={(e) =>
                        this.handleValidatepartnerId(e, "partnerId")
                      }
                      placeholder="Enter Partner Id"
                      className={`form-input ${
                        errors.partnerId ? "error-input-border" : ""
                      }`}
                    />
                    {errors.partnerId && (
                      <span className="errorMsg">
                        {errors.partnerId === true
                          ? "Please enter valid Partner Id"
                          : errors.partnerId}
                      </span>
                    )}
                  </div>

                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i> Pincode
                    </label>
                    <input
                      type="text"
                      pattern="\d*"
                      name="pincode"
                      maxLength="6"
                      value={form.pincode || ""}
                      onKeyPress={this.restrictAlphabets}
                      onChange={(e) => {
                        this.handlePincode(e, "pincode");
                      }}
                      disabled={!isITADMIN}
                      onBlur={(e) => this.handleValidatePincode(e, "pincode")}
                      placeholder="Enter Pincode"
                      className={`form-input ${
                        errors.pincode ? "error-input-border" : ""
                      }`}
                    />
                    {errors.pincode && (
                      <span className="errorMsg">
                        {errors.pincode === true
                          ? "Please enter valid pincode"
                          : errors.pincode}
                      </span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>Tehsil
                    </label>
                    <Select
                      value={
                        tehsilsdropdownvalue.find(
                          (item) => item.value === form.tehsil
                        ) || null
                      }
                      onChange={(e) => {
                        this.handleStateSelectChange(e, "tehsil");
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "tehsil")
                      }
                      name="tehsil"
                      options={tehsilsdropdownvalue}
                      placeholder="Select Tehsil"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className={`${errors.tehsil ? "error-input-border" : ""}`}
                      isDisabled={!isITADMIN}
                    />
                    {errors.tehsil && (
                      <span className="errorMsg">
                        {errors.tehsil === true
                          ? "Please select tehsil"
                          : errors.tehsil}
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>District
                    </label>
                    <Select
                      value={
                        districtDropdownValues.find(
                          ({ value }) => value === form.district
                        ) || null
                      }
                      onChange={(e) => {
                        this.handleStateSelectChange(e, "district");
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "district")
                      }
                      name="district"
                      options={districtDropdownValues}
                      placeholder="Select District"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className={`${errors.district ? "error-input-border" : ""}`}
                      isDisabled={!isITADMIN}
                    />
                    {errors.district && (
                      <span className="errorMsg">Please select district</span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label>
                      State
                    </label>
                    <Select
                      value={
                        stateDropdownValues.find(
                          ({ value }) => value === form.state
                        ) || null
                      }
                      onChange={(e) => {
                        this.handleStateSelectChange(e, "state");
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "state")
                      }
                      name="state"
                      options={stateDropdownValues}
                      placeholder="Select State"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className={`${errors.state ? "error-input-border" : ""}`}
                      isDisabled={this.props.action === "edit" || !isITADMIN}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>Region
                    </label>
                    <Select
                      value={
                        regionDropdownValues.find(
                          (opt) => opt.value === form.regionId
                        ) || null
                      }
                      onChange={(e) => {
                        this.handleRegionSelectChange(e);
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "regionId")
                      }
                      name="region"
                      options={regionDropdownValues}
                      placeholder="Select Region"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className={`${errors.regionId ? "error-input-border" : ""}`}
                      isDisabled={!isITADMIN}
                    />
                    {errors.regionId && (
                      <span className="errorMsg">Please select region</span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>Address
                    </label>
                    <textarea
                      maxLength="100"
                      name="address"
                      value={form.address || ""}
                      onChange={(e) => {
                        this.handleAddressChange(e, "address");
                      }}
                      disabled={!isITADMIN}
                      onBlur={(e) =>
                        this.handleValidateAddressChange(e, "address")
                      }
                      placeholder="Enter Address"
                      className={`form-input ${
                        errors.address ? "error-input-border" : ""
                      }`}
                      autoComplete="off"
                    />
                    {errors.address && (
                      <span className="errorMsg">
                        {errors.address === true
                          ? "Please enter valid address"
                          : errors.address}
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>Latitude
                    </label>
                    <input
                      type="text"
                      name="latitude"
                      value={form.latitude || ""}
                      onChange={(e) => {
                        this.handleLongitudeLatitude(e, "latitude");
                      }}
                      onBlur={(e) =>
                        this.ValidateLongitudeLatitude(e, "latitude")
                      }
                      disabled={!isITADMIN}
                      placeholder="Enter Latitude"
                      className={`form-input ${
                        errors.latitude ? "error-input-border" : ""
                      }`}
                    />
                    {errors.latitude && (
                      <span className="errorMsg">
                        {errors.latitude === true
                          ? "Please enter valid latitude"
                          : errors.latitude}
                      </span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>Longitude
                    </label>
                    <input
                      type="text"
                      name="longitude"
                      value={form.longitude || ""}
                      onChange={(e) => {
                        this.handleLongitudeLatitude(e, "longitude");
                      }}
                      disabled={!isITADMIN}
                      onBlur={(e) =>
                        this.ValidateLongitudeLatitude(e, "longitude")
                      }
                      placeholder="Enter Longitude"
                      className={`form-input ${
                        errors.longitude ? "error-input-border" : ""
                      }`}
                    />
                    {errors.longitude && (
                      <span className="errorMsg">
                        {errors.longitude === true
                          ? "Please enter valid longitude"
                          : errors.longitude}
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label>
                      Spokes
                    </label>
                    <Select
                      value={form.spokeEntitySet || []}
                      onChange={this.handleSpoke}
                      name="spoke"
                      placeholder="Select spoke / Spokes (Optional)"
                      options={unmappedspokes}
                      getOptionLabel={(option) => option.spokeName}
                      getOptionValue={(option) => option.id}
                      className={`${
                        errors.spokeEntitySet ? "error-input-border" : ""
                      }`}
                      isDisabled={!isITADMIN}
                      isMulti={true}
                    />
                    {errors.spokeEntitySet && (
                      <span className="errorMsg">
                        Please select spoke / spokes
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>Date of Establishment
                    </label>
                    <div className="inner-addon right-addon">
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        placeholderText="DD-MM-YYYY"
                        selected={selectedDate}
                        onChange={this.handleDateOfEstablishment}
                        onBlur={(e) =>
                          this.handlevalidationDateOfEstablishment(
                            e,
                            "dateOfEstablishment"
                          )
                        }
                        className={`form-input ${
                          errors.dateOfEstablishment ? "error-input-border" : ""
                        }`}
                        disabled={!isITADMIN}
                        maxDate={new Date()}
                      />
                    </div>
                    {errors.dateOfEstablishment && (
                      <span className="errorMsg">
                        Please select date of establishment
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={form.isOperational !== undefined ? form.isOperational : true}
                          onChange={(e) => {
                            let { form } = this.state;
                            form.isOperational = e.target.checked;
                            this.setState({ form });
                          }}
                          name="isOperational"
                          color="primary"
                          disabled={!isITADMIN}
                        />
                      }
                      label={form.isOperational ? "Operational" : "Not Operational"}
                    />
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {isITADMIN && (
              <>
                {this.props.action === "edit" ? (
                  <Button
                    className="success"
                    onClick={() => this.handleSubmit(true)}
                  >
                    {form.status === true ? "Inactive" : "Active"}
                  </Button>
                ) : null}
              </>
            )}
            <Button className="btn-danger" onClick={this.handleModalClose}>
              Cancel
            </Button>
            {isITADMIN && (
              <Button
                className="btn-success"
                disabled={
                  disableSave ||
                  !form.regionId
                }
                onClick={() => this.handleSubmit(false)}
              >
                {this.props.action === "edit" ? "Update" : "Save"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
        <CloseModal
          show={showInner}
          button2={this.handleModalClose}
          button1={this.innerModalClose}
          title="Do you want to close?"
        />
      </React.Fragment>
    );
  }
}

export default AddEditBranch;